import React from 'react'

const EuroIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M8.375 10.5625C6.80625 10.5625 5.45 9.675 4.775 8.375H8.375V7.125H4.3625C4.33125 6.91875 4.3125 6.7125 4.3125 6.5C4.3125 6.2875 4.33125 6.08125 4.3625 5.875H8.375V4.625H4.775C5.45 3.325 6.8125 2.4375 8.375 2.4375C9.38125 2.4375 10.3062 2.80625 11.0187 3.41875L12.125 2.3125C11.1313 1.41875 9.8125 0.875 8.375 0.875C5.925 0.875 3.85 2.44375 3.075 4.625H0.875V5.875H2.7875C2.7625 6.08125 2.75 6.2875 2.75 6.5C2.75 6.7125 2.7625 6.91875 2.7875 7.125H0.875V8.375H3.075C3.85 10.5562 5.925 12.125 8.375 12.125C9.81875 12.125 11.1313 11.5813 12.125 10.6875L11.0125 9.58125C10.3062 10.1938 9.3875 10.5625 8.375 10.5625Z'
      fill='currentColor'
    />
  </svg>
)

export default EuroIcon
